import classNames from 'classnames';
import styles from './GridProducts.module.scss';

const GridProducts = ({ children, className }) => {
  return (
    <div
      className={classNames(['wrapper', className])}
      itemScope
      itemType='http://schema.org/Product'
    >
      <div className={styles.grid}>{children}</div>
    </div>
  );
};

export default GridProducts;
